import React from "react";
import PropTypes from "prop-types";
import { SubMenu } from "react-contextmenu";
import { buildList } from "./utils";

export default function ActionSubMenu({ name, actionLists, actionContext }){
	let [menuItems, hasItems] = buildList(actionLists, actionContext);

	// Don't display the trigger or anything if there are no displayable actions.
	if(!hasItems){
		return null;
	}

	return (
		<SubMenu
			title = {name}
		>
			{ menuItems }
		</SubMenu>
	);
}

ActionSubMenu.displayName = "ActionSubMenu";
ActionSubMenu.defaultProps = {
	name:">",
	actionLists:[],
	actionContext:{},
};

ActionSubMenu.propTypes ={
	name:PropTypes.string,
	actionLists:PropTypes.array,
	actionContext:PropTypes.object,
};
